// Utility function to get agent's full name
export const getAgentName = (agent) => {
  if (agent.firstName && agent.lastName) {
    return `${agent.firstName} ${agent.lastName}`;
  }
  return agent.name || 'Agent Name';
};

// Utility function to get agent's initials
export const getAgentInitials = (agent) => {
  if (agent.firstName) {
    return agent.firstName.charAt(0).toUpperCase();
  }
  if (agent.name) {
    return agent.name.charAt(0).toUpperCase();
  }
  return 'A';
};
